import CalendarEventPreview from './OneDayModal';

export default CalendarEventPreview;